import type { TablerIcon } from "@tabler/icons-react";
import type { ButtonHTMLAttributes, ReactElement } from "react";
import styles from "./IconRail.module.css";
import { RAIL_ICON_SIZE, RAIL_ICON_STROKE } from "./IconRail";

export interface IconControlButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "children"> {
  icon: TablerIcon;
  /** Required: icon-only control. */
  "aria-label": string;
  active?: boolean;
}

/**
 * The rail's 40px icon control, usable outside the rail (nav islands, sheet
 * headers). Same glyph spec, radius, hover and active treatment as the
 * toolbar buttons so every floating control reads as one family.
 */
export function IconControlButton({
  icon: Icon,
  active = false,
  className,
  title,
  ...rest
}: IconControlButtonProps): ReactElement {
  return (
    <button
      type="button"
      className={[
        styles.toolButton,
        active ? styles.toolButtonActive : "",
        className ?? ""
      ]
        .filter(Boolean)
        .join(" ")}
      aria-pressed={active || undefined}
      title={title ?? rest["aria-label"]}
      {...rest}
    >
      <Icon size={RAIL_ICON_SIZE} stroke={RAIL_ICON_STROKE} aria-hidden />
    </button>
  );
}
